import {persianCopy} from './persianTranslations.js';
const localizedCopy = {
  "tr": {
    "welcome": "Bugün hangi konuyu araştıralım?",
    "intro": "Mahmut Efendim’in sohbetleri ve kütüphane kaynakları üzerine sorun.",
    "create": "Yeni sohbet oluştur"
  },
  "en": {
    "welcome": "What shall we explore today?",
    "intro": "Ask about Mahmut Efendim’s talks and library sources.",
    "create": "Create a new chat"
  },
  "de": {
    "welcome": "Welches Thema möchten Sie heute erforschen?",
    "intro": "Fragen Sie zu Mahmut Efendims Gesprächen und Bibliotheksquellen.",
    "create": "Neues Gespräch erstellen"
  },
  "fr": {
    "welcome": "Quel sujet explorer aujourd’hui ?",
    "intro": "Posez une question sur les entretiens de Mahmut Efendim et la bibliothèque.",
    "create": "Créer une conversation"
  },
  "es": {
    "welcome": "¿Qué tema exploramos hoy?",
    "intro": "Pregunte sobre las conversaciones de Mahmut Efendim y la biblioteca.",
    "create": "Crear una conversación"
  },
  "ru": {
    "welcome": "Какую тему исследуем сегодня?",
    "intro": "Спросите о беседах Махмута Эфенди и библиотечных источниках.",
    "create": "Создать новый чат"
  },
  "ar": {
    "welcome": "ما الموضوع الذي نبحثه اليوم؟",
    "intro": "اسأل عن أحاديث محمود أفندي ومصادر المكتبة.",
    "create": "إنشاء محادثة جديدة"
  },
  "zh": {
    "welcome": "今天想探索什么主题？",
    "intro": "就 Mahmut Efendim 的讲座和图书馆资料提问。",
    "create": "创建新对话"
  }
};

localizedCopy.fa=persianCopy(localizedCopy.tr);
const namedGreetings = {
 tr:'Bugün hangi konuyu araştıralım, {name}?',
 en:'What shall we explore today, {name}?',
 de:'Welches Thema möchten Sie heute erforschen, {name}?',
 fr:'Quel sujet explorer aujourd’hui, {name} ?',
 es:'¿Qué tema exploramos hoy, {name}?',
 ru:'Какую тему исследуем сегодня, {name}?',
 ar:'ما الموضوع الذي نبحثه اليوم، {name}؟',
 zh:'{name}，今天想探索什么主题？',
 fa:'امروز درباره چه موضوعی تحقیق کنیم، {name}؟'
};

export function assistantGreeting(locale,user){
 const copy=localizedCopy[locale]||localizedCopy.tr;
 // Use only the signed-in account's name; never fall back to email or phone.
 const name=typeof user?.name==='string'?user.name.trim().split(/\s+/u)[0]:'';
 if(!user?.user_id||!name||name.length>40||!/^\p{L}[\p{L}\p{M}’'\-]*$/u.test(name))return copy.welcome;
 const caseLocale=locale==='tr'||!localizedCopy[locale]?'tr':locale;
 const givenName=name===name.toLocaleUpperCase(caseLocale)
  ?name[0].toLocaleUpperCase(caseLocale)+name.slice(1).toLocaleLowerCase(caseLocale):name;
 return (namedGreetings[locale]||namedGreetings.tr).replace('{name}',givenName);
}
export default localizedCopy;
